import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayCloseDirective } from './overlay-close/overlay-close.directive';
import { HeightDirective } from './height/height.directive';
import { EllipsisTooltipDirective } from './ellipsis-tooltip/ellipsis-tooltip.directive';
import { IntersectionObserverDirective } from './intersect-observer/intersect-observer.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [
    OverlayCloseDirective,
    HeightDirective,
    EllipsisTooltipDirective,
    IntersectionObserverDirective,
  ],
  exports: [
    OverlayCloseDirective,
    HeightDirective,
    EllipsisTooltipDirective,
    IntersectionObserverDirective,
  ],
})
export class SharedDirectiveModule {}
